'use memo';

import { AgxNotificationBox, AgxTypography, formatCurrency } from '@urbanx/agx.ui-components2';
import {
  EarlyReleaseOfDeposit,
  EarlyReleaseOfDepositDestinationOfTransfer,
} from '@urbanx/agx.campaigns.client';
import dayjs from 'dayjs';

interface EarlyReleaseSummaryProps {
  earlyRelease: EarlyReleaseOfDeposit;
  actionedBy: string;
}

const getDestinationLabel = (destination?: EarlyReleaseOfDepositDestinationOfTransfer) => {
  switch (destination) {
    case EarlyReleaseOfDepositDestinationOfTransfer.VendorSolicitor:
      return "Vendor's Solicitor";
    case EarlyReleaseOfDepositDestinationOfTransfer.Vendor:
      return 'Vendor';
    default:
      return destination ?? '-';
  }
};

const EarlyReleaseSummary = ({ earlyRelease, actionedBy }: EarlyReleaseSummaryProps) => {
  const warningTextColor = 'var(--text-warning)';
  const changedAt = earlyRelease.changeInfo?.changedAt
    ? dayjs(earlyRelease.changeInfo.changedAt).format('h:mm A [on] MMMM D, YYYY')
    : undefined;

  return (
    <AgxNotificationBox
      type="warning"
      heading=""
      body={
        <>
          <AgxTypography
            id="early-release-summary-heading"
            type="body_ui"
            size="medium"
            color={warningTextColor}
          >
            {changedAt ? `Early release submitted at ${changedAt}` : 'Early release submitted'}
          </AgxTypography>
          <ul className="agx-notification-list">
            <li>
              <AgxTypography
                id="early-release-summary-amount"
                type="body_ui"
                size="medium"
                color={warningTextColor}
              >
                Amount released: <strong>{formatCurrency(earlyRelease.amount ?? 0, 2)}</strong>
              </AgxTypography>
            </li>
            <li>
              <AgxTypography
                id="early-release-summary-recipient"
                type="body_ui"
                size="medium"
                color={warningTextColor}
              >
                Recipient:{' '}
                <strong>{getDestinationLabel(earlyRelease.destinationOfTransfer)}</strong>
              </AgxTypography>
            </li>
            <li>
              <AgxTypography
                id="early-release-summary-actioned-by"
                type="body_ui"
                size="medium"
                color={warningTextColor}
              >
                Actioned by: <strong>{actionedBy}</strong>
              </AgxTypography>
            </li>
          </ul>
        </>
      }
    />
  );
};

export default EarlyReleaseSummary;
